import axios from "axios";
import {ParkingBay} from "../Models/ParkingBay";
import {API_GET_PARKING_BAYS} from "../Config/Uri";

export interface GetAllParkingBaysResult {
    error: string | null;
    data: ParkingBay[] | null;
}

export function startGetAllParkingBays(): Promise<GetAllParkingBaysResult> {
    const url = API_GET_PARKING_BAYS();
    return axios({ url: url, method: "GET", withCredentials: true })
        .then(res => {
            if (res.data != null) {
                const data = JSON.parse(JSON.stringify(res.data)) as ParkingBay[];
                return {
                    error: null,
                    data: data
                } as GetAllParkingBaysResult;
            }
            return {
                error: null,
                data: null
            } as GetAllParkingBaysResult;
        })
        .catch(err => {
            if (err.response) {
                // client received an error response (5xx, 4xx)
                return Promise.reject({
                    error: err.response.data.message,
                    data: null
                } as GetAllParkingBaysResult);
            } else if (err.request) {
                // client never received a response, or request never left
                return Promise.reject({
                    error: err.message,
                    data: null
                } as GetAllParkingBaysResult);
            } else {
                // anything else
                return Promise.reject({
                    error: err.message,
                    data: null
                } as GetAllParkingBaysResult);
            }
        })
}
